import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
// import ErrorPageHandler from "../../components/errors/ErrorPageHandler";
// import useMe from "../../models/me/useMe";
// import ConfirmationModal from "../ConfirmationModal";
import Footer from "../Footer";
import Header from "../Header";
import Loader from "../Loader";
import ConfirmationModal from "../ConfirmationModal";

import "react-toastify/dist/ReactToastify.css";
import "./styles.scss";

const AdminLayout = () => {
  return (
    <>
      <div className="AdminLayout">
        <div className="AdminLayout__header">
          <Header />
        </div>
        <div className="AdminLayout__main">
          <Outlet />
        </div>
        <div className="AdminLayout__footer">
          <Footer />
        </div>
      </div>
      <ConfirmationModal />
      <Loader />
      <ToastContainer />
    </>
  );
};

export default AdminLayout;
